var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _c(
      "div",
      { staticClass: "card-body position-relative" },
      [
        _c("pulse-loader", {
          staticClass: "text-center",
          attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
        }),
        _vm._v(" "),
        !_vm.loading
          ? [
              _vm.legendData
                ? _c(
                    "div",
                    {
                      class: {
                        "alert p-1": true,
                        legend_block: true,
                        "alert-success": !_vm.legendData.exceed,
                        "alert-danger": _vm.legendData.exceed,
                      },
                    },
                    [
                      _vm.legendData.exceed
                        ? _c("p", [
                            _c("strong", [
                              _vm._v(_vm._s(_vm.legendData.data.length)),
                            ]),
                            _vm._v(" раз(а) лимит достигнут"),
                          ])
                        : _c("p", [_vm._v("Всегда в наличии*")]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("Chart", { attrs: { options: _vm.chartOptionsDelayed } }),
            ]
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }